import { render } from "./ReportBreakPreview.vue?vue&type=template&id=1f36a2ea&ts=true"
import script from "./ReportBreakPreview.vue?vue&type=script&lang=ts"
export * from "./ReportBreakPreview.vue?vue&type=script&lang=ts"

import "./ReportBreakPreview.vue?vue&type=style&index=0&id=1f36a2ea&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QChatMessage from 'quasar/src/components/chat/QChatMessage.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChatMessage});
